import { ApiError, apiFetch, parseErrorDetail } from "@/api/fetch";
import type { UsageRunDetail, UsageRunFilters, UsageRunPage, UsageSummary } from "../types";

export const RUNS_PAGE_SIZE = 50;

const getJson = async <T>(path: string): Promise<T> => {
  const response = await apiFetch(path);
  if (!response.ok) {
    throw new ApiError(await parseErrorDetail(response), response.status);
  }
  return response.json() as Promise<T>;
};

export const getUsageSummary = (days: number): Promise<UsageSummary> =>
  getJson<UsageSummary>(`/usage-tracking/summary?days=${days}`);

export const getUsageRuns = (filters: UsageRunFilters): Promise<UsageRunPage> => {
  const params = new URLSearchParams({
    days: String(filters.days),
    limit: String(RUNS_PAGE_SIZE),
    offset: String(filters.offset),
  });
  if (filters.runType) params.set("run_type", filters.runType);
  if (filters.user.trim()) params.set("user", filters.user.trim());
  return getJson<UsageRunPage>(`/usage-tracking/runs?${params}`);
};

export const getUsageRun = (runId: string): Promise<UsageRunDetail> =>
  getJson<UsageRunDetail>(`/usage-tracking/runs/${encodeURIComponent(runId)}`);
